import { Container } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { ReactNode } from 'react'
import Advisors from './Advisors'
import Companies from './Companies'
import styles from './Investors.module.scss'

export type ZoneInvestorsProps = {
  __typename: 'StrapiGQL_ComponentZonesInvestorsAndAdvisors'
  title: ReactNode
}
export default function ZoneInvestors({ title }: ZoneInvestorsProps) {
  return (
    <Container fluid={true}>
      <section className={styles.investors} id="investors">
        <Whitespace type="lg">
          <Container>
            <header className={styles.header}>
              <Heading level={2} type="lg" className={styles.title}>
                {title}
              </Heading>
            </header>
            <div className={styles.companies}>
              <Companies />
            </div>
            <div className={styles.advisors}>
              <Advisors />
            </div>
          </Container>
        </Whitespace>
      </section>
    </Container>
  )
}
